import { differenceInDays } from 'date-fns'
import { formatDate, toDate } from 'util/date/formatDate'
import { DumModel } from 'view/atendimentos/types/CidadaoAtendimento'

interface DumInfo {
  value: string
  lastUpdate: string | null
}

export function safeFormatDumInfo(
  dumInput: LocalDate | null,
  ultimaDum: DumModel,
  referenceDate: number
): DumInfo | null {
  if (dumInput == null && ultimaDum == null) {
    return null
  }

  if (dumInput != null) {
    return formatDumInfo(dumInput, referenceDate, referenceDate)
  }

  return formatDumInfo(ultimaDum.dum, ultimaDum.registradoEm, referenceDate)
}

function formatDumInfo(dum: LocalDate, registradoEm: LocalDate | number, referenceDate: number): DumInfo {
  const diffDumDays = differenceInDays(referenceDate, toDate(dum))
  const diffDumDaysText = 'dia'.pluralizeAndConcatValue(diffDumDays)

  return {
    value: `${formatDate(dum)} (${diffDumDaysText})`,
    lastUpdate: `Registrada em: ${formatDate(registradoEm)}`,
  }
}
